import { SettingsRounded } from "@mui/icons-material";
import { Button, IconButton, Stack, useMediaQuery } from "@mui/material";
import { useNavigate } from "react-router";
import { Links } from "../../../../constants";
import { useTeamPageLayoutContext } from "../TeamPageLayout";
import { Followers } from "./Followers";

const TeamActions = () => {
  const { team } = useTeamPageLayoutContext();
  const isMdUp = useMediaQuery((theme) => theme.breakpoints.up("md"));
  const navigate = useNavigate();

  return (
    <Stack
      direction="row"
      spacing={1}
      sx={{
        alignItems: "center",
      }}
    >
      <Followers />

      {team.isAdministrator &&
        (isMdUp ? (
          <Button
            startIcon={<SettingsRounded />}
            variant="outlined"
            onClick={() => navigate(Links.TeamSettings(team.slug))}
          >
            Settings
          </Button>
        ) : (
          <IconButton onClick={() => navigate(Links.TeamSettings(team.slug))}>
            <SettingsRounded />
          </IconButton>
        ))}
    </Stack>
  );
};

export { TeamActions };
